import TopicThree from "../crypto-market-contents/TopicThree";

const CryptoMarketContentThree = () => {
  return (
    <>
      {/* <TopicThree /> */}

      <div className="how__work__market">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>
              Trade Crypto Smarter, Safer, and Faster — Only with The Pips
            </h1>
            <p>
              The Pips brings you the ultimate crypto trading experience,
              merging robust technology with security and speed, giving traders
              the edge they need in an ever-changing digital landscape.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Institutional-Grade Infrastructure</h4>
                </div>
                <p>
                  {/* Enjoy deep liquidity, minimal downtime, and ultra-fast order
                  execution backed by enterprise-grade technology and global
                  data centers. */}
                  Experience deep liquidity and ultra-fast execution with
                  reliable global infrastructure.
                </p>
              </div>
            </div>

            {/* Email Inquiries */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Enhanced Security Framework</h4>
                </div>
                <p>
                  {/* With bank-grade encryption, cold wallet storage, and strict
                  compliance protocols, The Pips ensures your crypto assets and
                  data are protected at every step. */}
                  Your assets are protected with bank-grade encryption and
                  strict compliance.
                </p>
              </div>
            </div>

            {/* Our Office */}
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Seamless Multi-Asset Trading</h4>
                </div>
                <p>
                  {/* Trade crypto alongside forex, commodities, and stocks, all
                  within a single unified dashboard. Monitor, analyze, and
                  diversify without switching platforms. */}
                  Trade crypto, forex, stocks, and commodities in one unified
                  dashboard.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CryptoMarketContentThree;
